import * as React from 'react';
import { CalendarAppText, defaultText } from '../redux-state/interfaces/calendar-app-text.state';

const CalendarText = React.createContext<CalendarAppText>(defaultText);

export default CalendarText;